import React from 'react';
import { Facebook, Instagram, Youtube, MessageCircle, Send } from 'lucide-react';
import { useWebsiteSettings } from '../contexts/WebsiteSettingsContext';

const iconMap = {
  facebook: Facebook,
  instagram: Instagram,
  x: ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M18.244 2H21.5l-7.5 8.57L22.5 22h-6.56l-5.14-6.71L5.2 22H1.94l8.03-9.17L1.5 2h6.72l4.64 6.15L18.244 2zm-1.15 18h1.82L7.02 3.94H5.07L17.094 20z" />
    </svg>
  ),
  youtube: Youtube,
  whatsapp: MessageCircle,
  telegram: Send,
};

const SocialIcons = ({ className = '', itemClassName = '', size = 16 }) => {
  const { socialPlatforms } = useWebsiteSettings();
  if (!socialPlatforms.length) return null;

  return (
    <div className={className} data-testid="social-icons">
      {socialPlatforms.map((platform) => {
        const Icon = iconMap[platform.key] || MessageCircle;
        return (
          <a
            key={platform.key}
            href={platform.url}
            target="_blank"
            rel="noopener noreferrer"
            className={itemClassName}
            aria-label={platform.label}
            data-testid={`social-icon-${platform.key}`}
          >
            <Icon size={size} />
          </a>
        );
      })}
    </div>
  );
};

export default SocialIcons;
